import { render, staticRenderFns } from "./tagModal.vue?vue&type=template&id=46ecd297&scoped=true&lang=pug&"
import script from "./tagModal.vue?vue&type=script&lang=js&"
export * from "./tagModal.vue?vue&type=script&lang=js&"
import style0 from "./tagModal.vue?vue&type=style&index=0&id=46ecd297&scoped=true&lang=css&"
import style1 from "./tagModal.vue?vue&type=style&index=1&id=46ecd297&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecd297",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ecd297')) {
      api.createRecord('46ecd297', component.options)
    } else {
      api.reload('46ecd297', component.options)
    }
    module.hot.accept("./tagModal.vue?vue&type=template&id=46ecd297&scoped=true&lang=pug&", function () {
      api.rerender('46ecd297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/tagModal.vue"
export default component.exports